module.exports = __webpack_public_path__ + "static/media/musicIcon.613ad6a5.svg";